import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IntakeMedication, VisitSchedule, Patient, WaitingRoom, PatientPlan, Payment } from '../models/index';
import { Api, Session } from '../services/index';
import * as moment from 'moment';
import * as momenttz from 'moment-timezone';
import { MyModal } from '../components/modal/modal';
import { IntakePaymentCharge, PaymentMethodResult } from '../models/sf-payments';


@Component({
  selector: 'app-exam-medications',
  styleUrls: ['exam-review-request.css'],
  templateUrl: './exam-review-request.html'
})

export class ExamReviewRequest implements OnInit {

  @ViewChild('modalFollowUp') public _modalFollowUp: MyModal;

  avatar: string = '../../assets/images/ico-profile.png';
  patientId: number;
  intakeMedicationList: IntakeMedication[] = [];
  requestedAppointmentDate: Date;
  visitSchedule: VisitSchedule = new VisitSchedule;
  patient: Patient;
  loading: boolean = false;
  paymentMethods: Array<PaymentMethodResult> = [];
  defaultPaymentMethod: PaymentMethodResult;
  intakePayment: IntakePaymentCharge;
  intakeWaitingRoom: WaitingRoom;
  patientPlan: PatientPlan[] = [];
  payment: Payment = new Payment;
  selectedPlan: PatientPlan;


  constructor(private api: Api, 
              private route: ActivatedRoute,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              public session: Session) {
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
    this.patient = this.getPatient();
    if(this.patient.avatar){
      this.avatar = this.session.environment.settings.patientAvatarBucket + this.patient.avatar;
    }
    
    let medications = this.api.getIntakeMedications(this.session.serverIntake.intakeId);
    medications.subscribe(response => {
      this.intakeMedicationList = response;
      // if (!this.changeDetectorRef['destroyed']) {
      //   this.changeDetectorRef.detectChanges();
      // }
    });


   
  }

  ngOnInit() {

    console.log('-----------------------------------------------------------------this.session.intakeMedications:', this.session.intakeMedications);
    this.loading = false;
    this.requestedAppointmentDate = this.session.intakeScheduleDate;

    // let schedules = this.api.getVisitSchedule(this.session.serverIntake.intakeId);
    // schedules.subscribe(response => {
    //   if (response && response[0]) {
    //     let dateEnd = moment.utc(response[0].requestedAppointmentDate).local().format();
    //     this.requestedAppointmentDate = momenttz.tz(dateEnd, momenttz.tz.zone(momenttz.tz.guess()).name).format('YYYY-MM-DD HH:mm:ss');
    //     if (!this.changeDetectorRef['destroyed']) {
    //       this.changeDetectorRef.detectChanges();
    //     }
    //   }
    // })
    if (this.session.intakeLob ==='BH') {
      this.getPlansForVisitType(this.session.intakeBhType);
    }
  }
  removeAllergen(allergen) {
    for (let i = 0; i < this.session.intakeAllergens.length; i++) {
      if (this.session.intakeAllergens[i] == allergen) {
        this.session.intakeAllergens.splice(i, 1);
      }
    }
  }
  removeMedication(medication) {
    for (let i = 0; i < this.session.intakeMedications.length; i++) {
      if (this.session.intakeMedications[i] == medication) {
        this.session.intakeMedications.splice(i, 1);
      }
    }
  }
  removeFile(file) {
    this.api.removeIntakeFile(this.session.serverIntake.intakeId, file).subscribe(result => {
      this.getIntakeFiles();
    });
  }

  getIntakeFiles() {
    let _getIntakeFile = this.api.getIntakeFile(this.session.serverIntake.intakeId);
    _getIntakeFile.subscribe(response => {
      this.session.uploadFiles = response;
    })
  }
  getIntakeLOB(){
    return this.session.intakeLob;
  }

  getPatient(){
    return this.session.patient;
  }

  getClientIntake(){
    return this.session.clientIntake;
  }

  getIntakeAllergens(){
    return this.session.intakeAllergens;
  }

  getIntakeMedications(){
    return this.session.intakeMedications;
  }

  getUploadedFiles(){
    return this.session.uploadFiles;
  }

  trim(value) {
    return value.trim();
  }

  getPlansForVisitType(visitType) {
    let plans = this.api.getPatientPoliciesByLineOfBusiness(this.patientId, visitType);
    plans.subscribe(response => {
      this.patientPlan = response;
      var bestPolicy = this.getBestPolicy(response);
      this.setPolicy(bestPolicy);
      this.selectedPlan = bestPolicy;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    })


  }

  continue() {
    if (this.session.intakeLob === 'UC') {
      this.goToPayment();
    } else if (this.session.intakeLob === 'BH') {
      if (this.session.intakeBhType === 'PSI') {
        this.api.getPhycFollowUpStatus(Number(this.session.patientId), Number(this.session.intakeSchedule.providerId), Number(this.session.serverIntake.intakeId)).subscribe(result =>{
          let isPhycFollowUpStatus = result;
          if (isPhycFollowUpStatus === true){
            this._modalFollowUp.open();
          }else{
            this.setVisitType('PSI');
          }

        }, (err) => {
          this.setVisitType('PSI');
        });
        
       
      } else {
        this.loading = true;

        this.session.intakeBhType = 'THI';
        this.api.completeIntake(this.session.serverIntake.intakeId, this.selectedPlan.planId).subscribe(WaitingRoom => {
           this.intakeWaitingRoom = WaitingRoom;
           this.intakeWaitingRoom.IntakeId = Number(this.session.serverIntake.intakeId);
         });
         this.api.confirmScheduleRequest(this.session.scheduleReuestId).subscribe(res => {
           this.loading = false;
           this.router.navigate(['thankyou/' + this.session.serverIntake.intakeId]);
         }, (error) => {
           this.loading = false;
           this.router.navigate(['thankyou/' + this.session.serverIntake.intakeId]);
         });   
      }
    }
  }

  setPolicy(policy: PatientPlan) {
    this.selectedPlan = policy;
    //this.displayPayment = (this.session.intakeLob == 'BH' || (this.selectedPlan && this.selectedPlan.visitFee > 0));
  }
  getBestPolicy(policies: PatientPlan[]) {
    var retval;
    for (let policy of policies) {
      if (!retval || policy.visitFee < retval.visitFee) {
        retval = policy;
      }
    }

    return retval;
  }


  setVisitType(visitType){
    this.session.intakeBhType = visitType;
    this.goToPayment();
  }
  goToPayment(){
    this.router.navigate(['exam-form-of-payment/' + this.patientId]);
  }
}
